import { Link } from 'react-router-dom';

const tutorials = [
  {
    step: '01',
    title: '访问蜜桃视频主页',
    description: '通过浏览器访问蜜桃视频主页官网，或在应用商店下载蜜桃视频客户端。',
    icon: 'ri-global-line',
  },
  {
    step: '02',
    title: '注册或登录账号',
    description: '使用手机号、邮箱或微信快速注册，已有账号可直接登录蜜桃视频。',
    icon: 'ri-user-add-line',
  },
  {
    step: '03',
    title: '浏览内容分类',
    description: '在蜜桃视频主页浏览八大内容分类，找到你感兴趣的视频内容。',
    icon: 'ri-grid-line',
  },
  {
    step: '04',
    title: '享受观看体验',
    description: '点击视频开始观看，支持高清画质、弹幕互动、收藏分享等功能。',
    icon: 'ri-play-circle-line',
  },
];

export default function TutorialSection() {
  return (
    <section id="tutorial" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            快速上手指南
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            四步轻松上手蜜桃视频，开启你的精彩视频之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {tutorials.map((tutorial, index) => (
            <div key={index} className="relative p-6 rounded-lg bg-background-50 border border-background-200/70">
              <div className="text-4xl font-bold text-primary-100 font-heading absolute top-4 right-4">
                {tutorial.step}
              </div>
              <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${tutorial.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {tutorial.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {tutorial.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/variety"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始探索 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}